<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {}
};
</script>

<style lang="scss">
#app {
  min-width: 1280px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue